/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000, // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true, // Set to false to use static SVG
};

const greeting = {
  username: "Abdullah Khan",
  title: "Hi all, I'm Abdullah Khan",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building and deploying Web and Mobile applications with JavaScript / TypeScript / Reactjs / Nodejs / Nestjs / React Native / AWS / Docker and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/14vUW8Gx8jsbrDOa6-QZ87Myqm4ZRT3lJ/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Abdullah0332",
  linkedin: "https://www.linkedin.com/in/abdullah-khan-bab278198/",
  gmail: "abdullah.khan10032@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://web.facebook.com/profile.php?id=100042578957033",
  // medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/12455856/abdullah-khan",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true, // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER",
  skills: [
    emoji("⚡ Full Stack Developer having 2+ years of industry experience."),
    emoji("⚡ General Programming (JavaScript, TypeScript, Python)"),
    emoji(
      "⚡ Web Development (JavaScript, TypeScript, ReactJS, NodeJS, NestJS)"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    ),
    emoji("⚡ Open-Source Automation Tools (Dockers)"),
    emoji("⚡ Databases (MongoDB, MySQL, Postgresql)"),
    emoji("⚡ Operating Systems (Windows, Linux Server (Ubuntu))"),
    emoji(
      "⚡ Version Control Systems and Software Project management tools (Jira, GitHub, Bit Bucket)"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node",
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm",
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws",
    },
    {
      skillName: "heroku",
      fontAwesomeClassname: "fab fa-heroku",
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire",
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Education",
      logo: require("./assets/images/UELogo.jpg"),
      subHeader: "Bachelor of Science in Information Technology",
      duration: "September 2017 - May 2021",
    },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "85%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%",
    },
    {
      Stack: "Deployment",
      progressPercentage: "80%",
    },
  ],
  displayCodersrank: false, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "RepairDesk",
      companylogo: require("./assets/images/RepairdeskLogo.jpeg"),
      date: "December 2021 – Present",
      desc: `RepairDesk is a cloud based point-of-sale software, engineered specifically for small and medium sized computer and cell phone repair shops that allows technicians to track & monitor repair jobs, stay on top of inventory and manage multiple store locations.`,
      descBullets: [
        `Handle complete backend of marketplace that are
build in Nest JS with MongoDB and create API’s.`,
        `Manage all the data, parse complete excel files of
items and categories and store them in database.`,
        `Integrate RepairDesk Marketplace with
RepairDesk 2.0 (POS).`,
        `Integrate auth, checkout and other flow of
marketplace with different vendors like Mobile
Sentrix, Injured Gadgets etc`,
        `Integrate API’s with Admin Panel that are designed
in React JS.`,
        `Deal with new vendor, guide them about the flow,
requirements to integrate with RD Marketplace.`,
      ],
    },
    {
      role: "MERN Stack Developer",
      company: "WebWrites",
      companylogo: require("./assets/images/WebWritesLogo.jpeg"),
      date: "March 2021 – November 2021",
      desc: `WebWrite Inc. is a one-stop IT service provider that will take care of all your mobile and web application development needs by providing sophisticated and high-end solutions which are innovative and creative.`,
      descBullets: [
        `Create Fully responsive web and mobile application on MERN Stack.`,
        `Scraped complete data of some popular websites and enter it into CSV.`,
        `Participate in on-call rotations.`,
        `Deploy and manage the Web application on Heroku and AWS.`,
        `Implement Audio and Video calling with both Socket.io and twilio.`,
        `Integrate different payment methods e.g paypal, stripe, Iyzipay etc.`,
      ],
    },
    {
      role: "Software Engineer Intern",
      company: "BrandPa",
      companylogo: require("./assets/images/BrandpaLogo.jpeg"),
      date: "September 2019 – March 2021",
      desc: `Brandpa is on a mission to help Young Entrepreneurs & SMEs grow, like bigger brands, using new media technologies and integrated marketing communications.`,
      descBullets: [
        `Create Order Management System in Omnigear with React JS and integrate it with Backend in Node JS and also Authenticate
              the user with Firebase.`,
        `Create some component of DID in React JS.`,
        `Scraped complete data of some popular websites and enter it
              into CSV file using Python and their libraries Selenium,
              BeautifulSoap and Requests and also scrape many website data
              in python and JavaScript.`,
        `Create 2 Shopify App by React JS, Node JS, Material UI and
              GraphQL.`,
        ` Create a Chatbot by React and Node JS that are integrated with
              Dialogflow.`,
      ],
    },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/lawZebrasLogo.jpeg"),
      projectName: "LawZebras",
      projectDesc:
        "Law Zebras is a modern interface with complex and intelligent technology foundation that will help consumers find the right law professional and a great way for lawyers to market and showcase their services.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://lawzebras.com",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/alamulakaLogo.jpg"),
      projectName: "Alamulaka",
      projectDesc: `Alamulaka offers online one-on-one tutoring or group tuition for children ages 3-18. English, mathematics, Turkish, chess, art and many other fields.`,
      footerLink: [
        {
          name: "Visit Website",
          url: "https://alamulaka.com",
        },
      ],
    },
    {
      image: require("./assets/images/thankyouLogo.jpg"),
      projectName: "Thank You",
      projectDesc: `hank You gives you a physical link to the digital world in
the palm of your hand. Attach your own personalized media
messages to a unique Thank You QR code sticker then place
that sticker anywhere you want.`,
      footerLink: [
        {
          name: "Visit Website",
          url: "https://spreadthankyou.com",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  // subtitle:
  //   "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: `Certificate of Completion - Serverless Framework Bootcamp: Node.js, AWS & Microservices`,
      subtitle: "Udemy",
      image: require("./assets/images/UdemyLogo.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-4de0f888-7671-4a8a-98ee-e7cef5e630bf/",
        },
      ],
    },
    {
      title: `Core Team Member`,
      subtitle: `Google Developer Student Clubs`,
      image: require("./assets/images/gdscLogo.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://res.cloudinary.com/shopit-ab/image/upload/v1648492157/Certifications/DSCLead-Certificate2020_zjl4ez.png",
        },
      ],
    },

    {
      title: `Google Analytics for Beginners`,
      subtitle: `Google analytics`,
      image: require("./assets/images/googleAnalyticsLogo.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://analytics.google.com/analytics/academy/certificate/_h4mF4xrSeeRD3WbJBo58g",
        },
      ],
    },

    {
      title: `Certified Microsoft Innovative Educator`,
      subtitle: `Microsoft`,
      image: require("./assets/images/microsoftLogo.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://res.cloudinary.com/shopit-ab/image/upload/v1648492270/Certifications/Microsoft_zzs2ke.png",
        },
      ],
    },

    {
      title: `DevFest’21`,
      subtitle: `Google Developers Group`,
      image: require("./assets/images/gdgLogo.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://res.cloudinary.com/shopit-ab/image/upload/v1648491691/Certifications/Muhammad_Abdullah_Khan_sgk8fo.jpg",
        },
      ],
    },

    {
      title: `The Fundamentals of Digital Marketing`,
      subtitle: `Google Digital Garage`,
      image: require("./assets/images/googleLogo.jpeg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://res.cloudinary.com/shopit-ab/image/upload/v1651403216/Certifications/certificate_lwpclj.png",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  // title: "Blogs",
  // subtitle:
  //   "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  // displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  // blogs: [
  //   {
  //     url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
  //     title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
  //     description:
  //       "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
  //   },
  //   {
  //     url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
  //     title: "Why REACT is The Best?",
  //     description:
  //       "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
  //   },
  // ],
  // display: true, // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  // title: "TALKS",
  // subtitle: emoji(
  //   "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  // ),
  // talks: [
  //   {
  //     title: "Build Actions For Google Assistant",
  //     subtitle: "Codelab at GDG DevFest Karachi 2019",
  //     slides_url: "https://bit.ly/saadpasta-slides",
  //     event_url: "https://www.facebook.com/events/2339906106275053/",
  //   },
  // ],
  // display: true, // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  // title: emoji("Podcast 🎙️"),
  // subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  // // Please Provide with Your Podcast embeded Link
  // podcast: [
  //   "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo",
  // ],
  // display: true, // Set false to hide this section, defaults to true
};
const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3327198866",
  email_address: "abdullah.khan10032@gmail.com",
};

// Twitter Section

const twitterDetails = {
  // userName: "twitter", //Replace "twitter" with your twitter username without @
  // display: true, // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
};
